import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
type Testimonial = {
  initials: string;
  name: string;
  city: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  initials: 'MG',
  name: 'Martina G.',
  city: 'Rosario',
  quote: 'Venía operando hace dos años sin estructura ninguna. Con el módulo 1 empecé a entender por qué tomaba las decisiones que tomaba. Eso solo ya cambió todo.'
}, {
  initials: 'LF',
  name: 'Lucas F.',
  city: 'Córdoba',
  quote: 'No esperaba que algo tan simple como una guía para revisar mis decisiones me ayudara a no perder el hilo. Lo apliqué desde el primer día.'
}, {
  initials: 'VR',
  name: 'Valentina R.',
  city: 'Santa Fe',
  quote: 'Leí la primera estrategia y la entendí al toque. La puse en práctica con papel y lápiz antes de usar dinero real.'
}, {
  initials: 'EM',
  name: 'Ezequiel M.',
  city: 'Tucumán',
  quote: 'Lo que más me gustó es que no te venden magia. Te dan estructura y te hacen pensar.'
}, {
  initials: 'NB',
  name: 'Natalia B.',
  city: 'Mar del Plata',
  quote: 'Probé la segunda forma de empezar, paso a paso, antes de poner plata y fue muy revelador. Te ayuda a ser honesto con vos mismo.'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-257" data-mp="c7wpltra1ds5">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-brand text-brand" data-id="element-258" data-mp="zwy0rorhv314" data-mpi={index} />)}
    </div>;
}
export function Testimonials() {
  return <Section className="border-y border-white/5 bg-ink-900" data-id="element-259" data-mp="q6mlj62d17ex">
      <Reveal data-id="element-260" data-mp="q6cudf5kwu7n">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-261" data-mp="q4jxusoojqdd">
          Personas que ya empezaron el camino
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-262" data-mp="1it7c44b0hfhf">
        {testimonials.map((testimonial, index) => <Reveal key={testimonial.initials} delay={index * 0.05} className={index === testimonials.length - 1 ? 'sm:col-span-2' : ''} data-id="element-263" data-mp="1nnv5ohkvh02v" data-mpi={index}>
            <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-ink-850 p-6" data-id="element-264" data-mp="1sio18rqcwsx4">
              <div className="flex items-center gap-3" data-id="element-265" data-mp="1ogj8dv7qg0bj">
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full border border-brand/30 bg-brand-soft font-display text-sm font-bold text-brand" data-id="element-266" data-mp="1oj5j23px6vxz">
                  {testimonial.initials}
                </span>
                <div data-id="element-267" data-mp="19rddgjfxgw9g">
                  <figcaption className="text-sm font-semibold text-white" data-id="element-268" data-mp="19qvbd66l3ntm">{testimonial.name}</figcaption>
                  <p className="text-xs text-gray-500" data-id="element-269" data-mp="14tlc6yte7xsl">{testimonial.city}</p>
                </div>
                <div className="ml-auto" data-id="element-270" data-mp="10tkyjge4bqml"><Stars data-id="element-271" data-mp="10px32bp44u58" /></div>
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-gray-300" data-id="element-272" data-mp="vrlvy8q7cxqp">“{testimonial.quote}”</blockquote>
            </figure>
          </Reveal>)}
      </div>
    </Section>;
}